import React from 'react';
import { useSelector } from 'react-redux';
import useIsMobile from '../Hooks/useIsMobile';
import NavigationMegaMenu from './Navigation.MegaMenu';

const Navigation = ({
  contentLinks = [],
  onLinkHover,
  onMouseLeaveLink,
  activeMegaMenuLink,
  onMegaMenuClose,
}) => {
  const isMobile = useIsMobile();

  const leftLinks = contentLinks.filter((link) => !link.rightAligned);
  const rightLinks = contentLinks.filter((link) => link.rightAligned);

  return !isMobile ? (
    <div className="row">
      <div className="left header__menu columns">
        {leftLinks.map((link) => (
          <NavigationLink
            key={link.url + link.name}
            link={link}
            isActive={link.links?.length > 0 && activeMegaMenuLink == link}
            onLinkHover={() => onLinkHover(link)}
            onMouseLeaveLink={onMouseLeaveLink}
            onMegaMenuClose={onMegaMenuClose}
          />
        ))}
      </div>
      <div className="right header__menu">
        {rightLinks.map((link) => (
          <NavigationLink
            key={link.url + link.name}
            link={link}
            isActive={link.links?.length > 0 && activeMegaMenuLink == link}
            onLinkHover={() => onLinkHover(link)}
            onMouseLeaveLink={onMouseLeaveLink}
            onMegaMenuClose={onMegaMenuClose}
          />
        ))}
      </div>
    </div>
  ) : null;
};

const NavigationLink = ({
  link,
  isActive,
  onLinkHover,
  onMouseLeaveLink,
  onMegaMenuClose,
}) => (
  <>
    <a
      key={link.url + link.name}
      href={link.url || '#'}
      className={`${link.isSelected ? 'selected' : ''} ${
        isActive ? 'active' : ''
      }`}
      onMouseOver={onLinkHover}
      onMouseLeave={onMouseLeaveLink}
    >
      {link.name}
    </a>
    {link.links?.length > 0 && (
      <NavigationMegaMenu
        onMegaMenuClose={onMegaMenuClose}
        onMouseLeaveMegaMenu={onMouseLeaveLink}
        onMouseOverMegaMenu={() => onLinkHover(link)}
        link={link}
        open={isActive}
      />
    )}
  </>
);

export default Navigation;
